import { Control, Controller } from 'react-hook-form';
import { Radio, RadioGroup } from 'rsuite';
import { PRICE_APPLICATION_MODE_OPTIONS, PRICE_APPLICATION_MODES } from '../../constants';
import { PricingPermissionFormValues } from '../../schema';
import { PriceApplicationPermissionMode } from '../../types';
import styles from './PriceApplicationModeField.module.scss';

type PriceApplicationModeFieldProps = {
  control: Control<PricingPermissionFormValues>;
  disabled: boolean;
};

export const PriceApplicationModeField = ({ control, disabled }: PriceApplicationModeFieldProps) => (
  <Controller
    control={control}
    name="mode"
    render={({ field }) => (
      <RadioGroup
        className={styles.group}
        name={field.name}
        value={field.value}
        onChange={value => field.onChange(value as PriceApplicationPermissionMode)}
      >
        {PRICE_APPLICATION_MODES.map(mode => (
          <Radio key={mode} className={styles.option} value={mode} disabled={disabled}>
            <span className={styles.label}>{PRICE_APPLICATION_MODE_OPTIONS[mode].label}</span>
            <span className={styles.description}>{PRICE_APPLICATION_MODE_OPTIONS[mode].description}</span>
          </Radio>
        ))}
      </RadioGroup>
    )}
  />
);
